import { builtInFonts } from 'lib/reader';
import { getThemeOptions } from 'lib/reader/themes';

import type { LocaleMessages, ServerConfig } from 'shared-types';

interface Params {
  messages?: LocaleMessages;
  serverConfig: ServerConfig<'guest'>;
}

const getSettingsOptions = ({
  messages = {} as LocaleMessages,
  serverConfig
}: Params) => ({
  font:
    serverConfig.readerCustomTheme?.customFontTitle &&
    serverConfig.readerCustomTheme?.customFontValue
      ? [
          {
            id: serverConfig.readerCustomTheme.customFontValue,
            label: serverConfig.readerCustomTheme.customFontTitle,
            value: serverConfig.readerCustomTheme.customFontValue
          }
        ]
      : [
          ...builtInFonts.filter(
            (font) => serverConfig.readerBuiltInFonts[font.id]
          )
        ],
  fontSize: [
    {
      id: 'small',
      label: messages.readerSettingsFontSizeSmall,
      value: 'small'
    },
    {
      id: 'medium',
      label: messages.readerSettingsFontSizeMedium,
      value: 'medium'
    },
    {
      id: 'large',
      label: messages.readerSettingsFontSizeLarge,
      value: 'large'
    },
    {
      id: 'huge',
      label: messages.readerSettingsFontSizeHuge,
      value: 'huge'
    }
  ],
  theme: serverConfig.readerCustomTheme?.id
    ? [
        {
          id: serverConfig.readerCustomTheme.id,
          label: serverConfig.readerCustomTheme.title,
          value: serverConfig.readerCustomTheme.id
        }
      ]
    : [
        ...getThemeOptions({ messages }).filter(
          (theme) => serverConfig.readerBuiltInThemes[theme.value]
        )
      ],
  ...(serverConfig.readerEnablePagesView
    ? {
        view: [
          {
            id: 'continuous',
            label: messages.readerSettingsViewContinuous,
            value: 'continuous'
          },
          {
            id: 'pages',
            label: messages.readerSettingsViewPages,
            value: 'pages'
          }
        ]
      }
    : {})
});

export default getSettingsOptions;
